<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12 pb-4">
          <ChangeMasterDomain :is-primary-site="true" :site="site" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 pb-4">
          <PointerDomainsTable :site="site" :pointer-domains="pointerDomains" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import ChangeMasterDomain from "@/components/smart/cards/ChangeMasterDomain";
import PointerDomainsTable from "@/components/smart/tables/PointerDomainsTable";
import store from "@/store";

export default {
  name: "DevSiteDomainOptionsPage",
  components: { ChangeMasterDomain, PointerDomainsTable },
  setup() {
    const site = computed(() => store.getters["devSites/getItem"]);
    const pointerDomains = computed(() => store.state.pointerDomains);

    onMounted(() => {
      store.dispatch("pointerDomains/getList", site.value.id);
    });

    return {
      site,
      pointerDomains,
    };
  },
};
</script>
